/**
 * Format physician name for display
 */
export const formatPhysicianName = (firstName?: string, lastName?: string): string => {
  if (!firstName && !lastName) return '';
  if (!firstName) return lastName || '';
  if (!lastName) return firstName;
  return `${lastName}, ${firstName}`;
};
